module.exports = __webpack_public_path__ + "img/arbunize.d1e92803.png";